export const CampaignMediaSelection = {
  // Open and close "Confirm Campaign  Media Selection" from
  OPEN_CONFIRM_CAMPAIGN_MEDIA_SELECTION_MODAL:
    "OPEN_CONFIRM_CAMPAIGN_MEDIA_SELECTION_MODAL",
  CLOSE_CONFIRM_CAMPAIGN_MEDIA_SELECTION_MODAL:
    "CLOSE_CONFIRM_CAMPAIGN_MEDIA_SELECTION_MODAL",
};
